import siteConfig from "../config/siteConfig";

const amount = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? Math.max(0, parsed) : 0;
};

export function findPromotion(code, promotions = siteConfig.promotions || []) {
  const normalizedCode = String(code || "").trim().toUpperCase();
  if (!normalizedCode) return null;

  return (
    promotions.find(
      (promotion) =>
        String(promotion.code || "").trim().toUpperCase() === normalizedCode
    ) || null
  );
}

export function promotionDiscount(promotion, subtotal) {
  const orderSubtotal = amount(subtotal);
  if (!promotion || orderSubtotal < amount(promotion.minimumSubtotal)) return 0;

  if (promotion.type === "fixed") {
    return Math.min(orderSubtotal, amount(promotion.value));
  }

  if (promotion.type === "percentage") {
    return Math.min(
      orderSubtotal,
      orderSubtotal * (Math.min(100, amount(promotion.value)) / 100)
    );
  }

  return 0;
}
